import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {(path: string) => void} deps.navigate
 * @param {(key: string) => string} deps.t
 */
export function usePostCatalog({ callApiWithWorker, navigate, t }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["createOffering"],
    mutationFn: async (payload) => {
      return callApiWithWorker(`/dataset-offers`, {
        method: "POST",
        body: payload,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["datasetOffers"] });
      queryClient.invalidateQueries({ queryKey: ["datasetOfferings"] });

      showSuccessToast(t("createdSubMessage", "Creation successfully"), {
        title: t("createdMessage"),
      });
      navigate("/dataoffering", { replace: true });
    },
    onError: (error) => {
      console.error("Error al crear el dataset offering:", error);
      showErrorAlert(error);
    },
  });
}
